export const UpsBYOAService = Object.freeze({
  UPSGround: '26',
  WorldwideExpressPlus: '29',
  WorldwideExpress: '30',
  WorldwideExpedited: '33',
  WorldwideSaver: '34',
  Standard: '35',
  UPSSurePostLessthan1lb: '90',
  UPSSurePost1lborGreater: '91',
  UPSSurePostBPM: '92',
  UPSSurePostMedia: '95',
  GroundInternational: '238',
  SecondDayAir: '28',
});
